import { z } from 'zod/v4';
import { HIDTO } from '@/entities/monitoring/hi/@x/ci'; // from prior message

// CIHIValuesResponse
export const CIHIValuesResponseDTO = z.object({
  ci_id: z.uuid(),
  status: z.array(HIDTO),
});
export type CIHIValues = z.infer<typeof CIHIValuesResponseDTO>;

// If HI is same as HIDTO; otherwise define HISchema accordingly

// CIStatusResponse
export const CIStatusResponseDTO = z.object({
  ci_id: z.uuid(),
  value: z.number(),
  status: z.array(HIDTO).optional(),
});
export type CIStatus = z.infer<typeof CIStatusResponseDTO>;